import { render, staticRenderFns } from "./ClassReceiptsCourseSemester.vue?vue&type=template&id=0087a1d4&"
import script from "./ClassReceiptsCourseSemester.vue?vue&type=script&lang=js&"
export * from "./ClassReceiptsCourseSemester.vue?vue&type=script&lang=js&"
import style0 from "./ClassReceiptsCourseSemester.vue?vue&type=style&index=0&id=0087a1d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports